import { Assessment } from '@mui/icons-material';
import { Button, Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ReportExport } from './ReportExport';

export interface ReportExportParams {
  format: string;
  definitionId: string;
}

interface GipReportActionsProps {
  report: { id: string; type: string };
  exportFn: (params: ReportExportParams) => string;
  onClone: () => void;
}

/**
 * Actions for GIP report detail: clone and export (single button that opens
 * format/definition dialog and triggers download via exportFn).
 */
export function GipReportActions({ report, exportFn, onClone }: GipReportActionsProps) {
  return (
    <Stack spacing={2}>
      <Button variant="outlined" fullWidth onClick={onClone} startIcon={<Assessment />}>
        <FormattedMessage id="audit.reportsView.cloneBtn" defaultMessage="Visualizar resultados" />
      </Button>
      <ReportExport report={report} exportFn={exportFn} />
    </Stack>
  );
}
